var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { dataimpService } from "~/config/server";
import { NetService } from "~/utils/net.service";
import { Inject, Debounce } from "~/core/decorator";
import { Service } from "~/core/service";
var ImportTemplateService = /** @class */ (function (_super) {
    __extends(ImportTemplateService, _super);
    function ImportTemplateService() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * 多条件查询导入模板
     */
    ImportTemplateService.prototype.findAllImportTemplate = function (data, page, sort, loading) {
        return this.netService.send({
            server: dataimpService.importTemplateController.findAllImportTemplate,
            data: data,
            page: page,
            sort: sort,
            loading: loading
        });
    };
    /**
     * 解析excel表头
     */
    ImportTemplateService.prototype.analyzeExcelTitle = function (data, loading) {
        return this.netService.send({
            server: dataimpService.importTemplateController.analyzeExcelTitle,
            data: data,
            loading: loading
        });
    };
    /**
     * 获取案件字段
     */
    ImportTemplateService.prototype.getCaseProperty = function (type, loading) {
        return this.netService.send({
            server: dataimpService.importTemplateController.getCaseProperty,
            data: {
                type: type
            },
            loading: loading
        });
    };
    /**
     * 新增模板
     */
    ImportTemplateService.prototype.addImportTemplate = function (data, loading) {
        return this.netService.send({
            server: dataimpService.importTemplateController.addImportTemplate,
            data: data,
            loading: loading
        });
    };
    /**
     * 删除模板
     */
    ImportTemplateService.prototype.deleteTemplate = function (templateId, loading) {
        return this.netService.send({
            server: dataimpService.importTemplateController.deleteTemplate,
            data: {
                templateId: templateId
            },
            loading: loading
        });
    };
    /**
     * 获取模板信息
     */
    ImportTemplateService.prototype.getImportTemplateById = function (templateId, loading) {
        return this.netService.send({
            server: dataimpService.importTemplateController.getImportTemplateById,
            data: {
                templateId: templateId
            },
            loading: loading
        });
    };
    /**
     * 修改模板
     */
    ImportTemplateService.prototype.modifyImportTemplate = function (data, loading) {
        return this.netService.send({
            server: dataimpService.importTemplateController.modifyImportTemplate,
            data: data,
            loading: loading
        });
    };
    /**
     * 查询委托方下模板
     */
    ImportTemplateService.prototype.getTemplateByPrincipal = function (data, loading) {
        return this.netService.send({
            server: dataimpService.importTemplateController.getTemplateByPrincipal,
            data: {
                principalId: data.principalId,
                type: data.type,
            },
            loading: loading
        });
    };
    /**
     * 解析Excel数据模板头信息
     */
    ImportTemplateService.prototype.checkTemplate = function (data, loading) {
        return this.netService.send({
            server: dataimpService.importTemplateController.checkTemplate,
            data: data,
            loading: loading
        });
    };
    __decorate([
        Inject(NetService)
    ], ImportTemplateService.prototype, "netService", void 0);
    __decorate([
        Debounce()
    ], ImportTemplateService.prototype, "findAllImportTemplate", null);
    __decorate([
        Debounce()
    ], ImportTemplateService.prototype, "analyzeExcelTitle", null);
    __decorate([
        Debounce()
    ], ImportTemplateService.prototype, "getCaseProperty", null);
    __decorate([
        Debounce()
    ], ImportTemplateService.prototype, "addImportTemplate", null);
    __decorate([
        Debounce()
    ], ImportTemplateService.prototype, "deleteTemplate", null);
    __decorate([
        Debounce()
    ], ImportTemplateService.prototype, "getImportTemplateById", null);
    __decorate([
        Debounce()
    ], ImportTemplateService.prototype, "modifyImportTemplate", null);
    __decorate([
        Debounce()
    ], ImportTemplateService.prototype, "getTemplateByPrincipal", null);
    __decorate([
        Debounce()
    ], ImportTemplateService.prototype, "checkTemplate", null);
    return ImportTemplateService;
}(Service));
export { ImportTemplateService };
